if (!customElements.get('sw-load-more')) {
  class SwLoadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-sw-load-more]');
      this.onClick = this.onClick.bind(this);
      this.button?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }

    async onClick(event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      if (this.loading) return;

      const grid = this.closest('#ProductGridContainer')?.querySelector('[data-sw-grid]');
      if (!grid) {
        window.location.assign(this.button.href);
        return;
      }

      this.setLoading(true);
      const url = new URL(this.button.href, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(`Load more failed: ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = Array.from(doc.querySelectorAll('[data-sw-grid] > li'));
        const firstNew = items[0];

        items.forEach((item) => {
          item.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--cancel'));
          item.classList.add('sw-load-more__new');
          grid.appendChild(item);
        });

        const focusTarget = firstNew?.querySelector('a[href]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });

        const next = doc.querySelector('sw-load-more');
        if (next) this.replaceWith(next);
        else this.remove();
      } catch (error) {
        console.error(error);
        window.location.assign(this.button.href);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      this.loading = loading;
      this.classList.toggle('is-loading', loading);
      this.button?.setAttribute('aria-busy', String(loading));
    }
  }

  customElements.define('sw-load-more', SwLoadMore);
}
